<script setup>
import { useRouter } from 'vue-router';
import { formatPlainDateByRegion } from '../../helpers';

const props = defineProps({
    post: {
        type: Object,
        required: true,
    },
});

const router = useRouter();

const goToPost = () => {
    if (props.post?.slug?.name) {
        router.push(`/hkcmnews/${props.post.slug.name}`);
    }
};
</script>

<template>
    <div @click="goToPost"
        class="flex items-center p-2 rounded-lg border border-gray-200 transition-all ease-in-out hover:border-blue gap-2 cursor-pointer">
        <div class="flex-grow">
            <div class="flex flex-row items-center gap-2">
                <p class="text-sm text-gray-600">{{ formatPlainDateByRegion(post.published_at) }}</p>
            </div>
            <p class="font-semibold text-sm">{{ $translate(post.title) }}</p>
        </div>
    </div>
</template>
